import type { ReactElement } from "react";
import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import Highcharts from "highcharts";

/**
 * Renders a ReactElement to HTML and ensures it does not trigger warnings in Highcharts.
 *
 * @note Do not add arbitrary attrs! see https://assets.highcharts.com/errors/33/
 */
export const renderToHighchartsHtml = (node: ReactElement): string => {
  // Allow "data-testid" attributes in chart
  const { allowedAttributes } = Highcharts.AST;

  if (!allowedAttributes.includes("data-testid")) {
    allowedAttributes.push("data-testid");
  }

  const container = document.createElement("div");
  flushSync(() => {
    createRoot(container).render(node);
  });

  return container.innerHTML;
};
